<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Настройки оповещений</h2>
            </div>
        </div>
        <section>
            <div class="columns">
                <div class="column">
                    <b-tabs expanded type="is-toggle">
                        <b-tab-item expanded label="Sms" icon="message">
                            <div class="columns">
                                <div class="column">
                                    <h2 class="title is-5">Цепочка SMS сообщений</h2>
                                </div>
                                <div class="column">
                                    <b-button class="is-pulled-right"
                                              type="is-primary"
                                              icon-right="plus" @click="create('sms')">
                                        Добавить
                                    </b-button>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <p>Доступные переменные для текста: </p>
                                    <p><b>{short_link}</b> - Короткая ссылка</p>
                                    <p><b>{name}</b> - Имя клиента</p>
                                    <p>Доступные переменные для ссылки: </p>
                                    <p><b>{aff_sub1}</b> - Aff_sub1 пользователя</p>
                                    <p><b>{aff_sub2}</b> - Aff_sub2 пользователя</p>
                                    <p><b>{aff_sub3}</b> - Aff_sub3 пользователя</p>
                                    <p><b>{aff_sub4}</b> - Aff_sub4 пользователя</p>
                                    <p><b>{aff_sub5}</b> - Aff_sub5 пользователя</p>
                                    <p><b>{click_uuid}</b> - Click_uuid пользователя</p>
                                    <p><b>{reg_date}</b> - Дата регистрации пользователя</p>
                                    <p><b>{phone}</b> - Телефон пользователя</p>                 
                                </div>
                            </div>

                            <div class="columns scrollable" ref="scrollable">
                                <draggable class="column"
                                           v-model="settings.sms"
                                           draggable=".draggable-config-sms"
                                           v-bind="dragOptions">
                                    <transition-group type="transition" class="timeline">
                                        <div class="draggable-config-sms" v-if="settings.sms" v-for="(sms, index) in settings.sms" :key="'key_' + index">
                                            <div class="timeline-item">
                                                <div class="timeline-marker is-icon is-primary"><span>{{index+1}}</span></div>
                                                <div class="timeline-content">
                                                    <div class="columns notification-row ">
                                                        <div class="column">
                                                            <div class="columns">
                                                                <div class="column is-1">
                                                                    <div>
                                                                        <i class="icon is-medium mdi mdi-dark mdi-menu" style="font-size: 24px;"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="column">
                                                                    <b-field label="ID">
                                                                        <b-input v-model="sms.id" disabled></b-input>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column is-4">
                                                                    <b-field label="Ссылка">
                                                                        <b-input v-model="sms.url"></b-input>
                                                                    </b-field>
                                                                    <b-field label="Название">
                                                                        <b-input v-model="sms.name"></b-input>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column">
                                                                    <b-field expanded label="A/B">
                                                                        <v-checkbox v-model="sms.is_ab_type"></v-checkbox>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column is-4" v-if="!sms.is_ab_type">
                                                                    <b-field expanded label="Шаблон СМС">
                                                                        <b-input expanded maxlength="200" type="textarea" v-model="sms.text_template_a"></b-input>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column is-4" v-if="sms.is_ab_type">
                                                                    <b-field expanded label="Шаблон СМС(A)">
                                                                        <b-input expanded maxlength="200" type="textarea" v-model="sms.text_template_a"></b-input>
                                                                    </b-field>
                                                                    <b-field expanded label="Шаблон СМС(B)">
                                                                        <b-input expanded maxlength="200" type="textarea" v-model="sms.text_template_b"></b-input>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column is">
                                                                    <b-field label="Задержка (ч.)">
                                                                        <b-input v-model="sms.delay"></b-input>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column">
                                                                    <b-field label="Скрыть">
                                                                        <b-tooltip>
                                                                            <b-button
                                                                                v-if="sms.isUsed"
                                                                                icon-right="eye-outline"
                                                                                @click="switchShow(sms)"
                                                                            ></b-button>
                                                                            <b-button
                                                                                v-else
                                                                                icon-right="eye-off-outline"
                                                                                @click="switchShow(sms)"
                                                                            ></b-button>
                                                                        </b-tooltip>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column">
                                                                    <b-field label="Удалить">
                                                                        <b-button class="button is-danger" icon-right="trash-can" @click="remove('sms', index)">
                                                                        </b-button>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column" v-if="!!sms.offer">
                                                                    <b-field label="Скрыто" v-if="!sms.offer.show">
                                                                        <b-tag type="is-danger" size="is-medium">
                                                                            <b-icon icon="alert"></b-icon>
                                                                        </b-tag>
                                                                    </b-field>
                                                                </div>
                                                            </div>
                                                            <div class="columns">
                                                                <div class="column is-1">
                                                                    <div>
                                                                    </div>
                                                                </div>
                                                                <div class="column is-2">
                                                                    <b-field label="Тип канала?">
                                                                        <b-select placeholder="" icon="duck" v-model="sms.channel">
                                                                            <option
                                                                                    v-for="channel in channels"
                                                                                    :value="channel.id"
                                                                                    :key="channel.id">
                                                                                {{ channel.name }}
                                                                            </option>
                                                                        </b-select>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column is-2" v-if="sms.channel === 'char'">
                                                                    <b-field label="Имя отправителя">
                                                                        <b-select placeholder="" icon="duck" v-model="sms.sender" @input="changeSenDom(index, 'sender')">
                                                                            <option
                                                                                    v-for="sender in senders"
                                                                                    :value="sender"
                                                                                    :key="sender">
                                                                                {{ sender}}
                                                                            </option>
                                                                        </b-select>
                                                                    </b-field>
                                                                </div>
                                                                <div class="column is-2">
                                                                    <b-field label="Домен">
                                                                        <b-select placeholder="" icon="duck" v-model="sms.domain" @input="changeSenDom(index, 'domain')">
                                                                            <option
                                                                                    v-for="domain in domains"
                                                                                    :value="domain"
                                                                                    :key="domain">
                                                                                {{ domain }}
                                                                            </option>
                                                                        </b-select>
                                                                    </b-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </draggable>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <b-button class="is-pulled-right "
                                              type="is-primary"
                                              @click="save('sms')">
                                        Сохранить
                                    </b-button>
                                </div>
                            </div>

                        </b-tab-item>
                        <b-tab-item expanded label="Call" icon="phone">
                            <div class="columns">
                                <div class="column">
                                    <h2 class="title is-5">Цепочка call сообщений</h2>
                                </div>
                                <div class="column">
                                    <b-button class="is-pulled-right"
                                              type="is-primary"
                                              icon-right="plus" @click="create('call')">
                                        Добавить
                                    </b-button>
                                </div>
                            </div>
                            <div class="columns scrollable" ref="scrollable">
                                <draggable class="column"
                                           v-model="settings.call"
                                           draggable=".draggable-config-call"
                                           v-bind="dragOptions">
                                    <transition-group type="transition" class="timeline">
                                        <div class="draggable-config-call" v-if="settings.call" v-for="(call, index) in settings.call" :key="'key_' + index">
                                            <div class="timeline-item">
                                                <div class="timeline-marker is-icon is-primary"><span>{{index+1}}</span></div>
                                                <div class="timeline-content">
                                                    <div class="columns notification-row is-vcentered">
                                                        <div class="column">
                                                            <div>
                                                                <i class="icon is-medium mdi mdi-dark mdi-menu" style="font-size: 24px;"></i>
                                                            </div>
                                                        </div>
                                                        <div class="column">
                                                            <b-field label="ID">
                                                                <b-input v-model="call.id" disabled></b-input>
                                                            </b-field>
                                                        </div>
                                                        <div class="column">
                                                          <b-field label="Использовать дежурный номер?">
                                                            <b-switch v-model="call.from_duty_phone"></b-switch>
                                                          </b-field>
                                                          <b-field label="Название">
                                                            <b-input v-model="call.name"></b-input>
                                                          </b-field>
                                                        </div>
                                                        <div class="column" v-if="!call.from_duty_phone">
                                                          <b-field label="Список номеров:">
                                                            <b-select
                                                              placeholder="Номер телефона"
                                                              icon="duck"
                                                              v-model="call.outgoing_phone"
                                                              :loading="isPhonesLoading"
                                                            >
                                                              <option
                                                                v-for="phone in phones"
                                                                :value="phone.phone"
                                                                :key="phone.id"
                                                              >
                                                                {{ phone.phone }}
                                                              </option>
                                                            </b-select>
                                                          </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field expanded label="A/B">
                                                                <v-checkbox v-model="call.is_ab_type"></v-checkbox>
                                                            </b-field>
                                                        </div>
                                                        <div class="column" v-if="!call.is_ab_type">
                                                            <b-field label="Шаблон">
                                                                <b-select placeholder="" icon="duck" v-model="call.call_template_a">
                                                                    <option
                                                                            v-for="template in templates"
                                                                            :value="template.id"
                                                                            :key="template.id">
                                                                        {{ template.name }}
                                                                    </option>
                                                                </b-select>
                                                            </b-field>
                                                        </div>
                                                        <div class="column" v-if="call.is_ab_type">
                                                            <b-field label="Шаблон A">
                                                                <b-select placeholder="" icon="duck" v-model="call.call_template_a">
                                                                    <option
                                                                            v-for="template in templates"
                                                                            :value="template.id"
                                                                            :key="template.id">
                                                                        {{ template.name }}
                                                                    </option>
                                                                </b-select>
                                                            </b-field>
                                                            <b-field label="Шаблон В">
                                                                <b-select placeholder="" icon="duck" v-model="call.call_template_b">
                                                                    <option
                                                                            v-for="template in templates"
                                                                            :value="template.id"
                                                                            :key="template.id">
                                                                        {{ template.name }}
                                                                    </option>
                                                                </b-select>
                                                            </b-field>
                                                        </div>
                                                        <div class="column is-2">
                                                            <b-field label="Задержка (ч.)">
                                                                <b-input v-model="call.delay"></b-input>
                                                            </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field label="Скрыть">
                                                                <b-tooltip>
                                                                    <b-button
                                                                        v-if="sms.isUsed"
                                                                        icon-right="eye-outline"
                                                                        @click="switchShow(call)"
                                                                    ></b-button>
                                                                    <b-button
                                                                        v-else
                                                                        icon-right="eye-off-outline"
                                                                        @click="switchShow(call)"
                                                                    ></b-button>
                                                                </b-tooltip>
                                                            </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field label="Удалить">
                                                                <b-button class="button is-danger" icon-right="trash-can" @click="remove('call', index)">
                                                                </b-button>
                                                            </b-field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </draggable>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <b-button class="is-pulled-right "
                                              type="is-primary"
                                              @click="save('call')">
                                        Сохранить
                                    </b-button>
                                </div>
                            </div>
                        </b-tab-item>
                    </b-tabs>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";

export default {
  name: 'NotificationSettings',
  components: {
    draggable,
    MultiplySelect,
  },
  data() {
      return {
          channels: [{id:'char', name: 'Буква'}, {id:'digit', name: 'Цифра'}],
      };
  },
  created() {
    this.$store.dispatch('GET_PHONES');
    this.$store.dispatch('GET_TEMPLATES');
    this.$store.dispatch('GET_NOTIFICATION_SETTINGS');
    this.$store.dispatch('GET_SMS_INFO');
  },
  computed: {
    domains() {
      return this.$store.getters.SMS_DOMAINS;
    },
    senders() {
      return this.$store.getters.SMS_SENDERS;
    },
    settings() {
      return this.$store.getters.NOTIFICATION_SETTINGS;
    },
    isPhonesLoading() {
      return this.$store.getters.PHONES_IS_LOADING;
    },
    phones() {
      return this.$store.getters.PHONES;
    },
    isLoading() {
      return this.$store.getters.SET_NOTIFICATION_SETTINGS_LOADING;
    },
    dragOptions() {
      return {
        animation: 200,
        scroll: true,
        scrollSensitivity: 100,
        scrollSpeed: 10,
      };
    },
    templates() {
        return this.$store.getters.TEMPLATES;
    },
  },
  methods: {
    create(type) {
      switch (type) {
        case 'sms':
          this.settings.sms.push({ type: 'sms', extra: {}, is_ab_type: false, isUsed: true});
          break;
        case 'call':
          this.settings.call.push({ type: 'call', extra: {}, is_ab_type: false, isUsed: true});
          break;
      }
    },
    remove(type, index) {
      switch (type) {
        case 'sms':
          this.settings.sms.splice(index, 1);
          break;
        case 'call':
          this.settings.call.splice(index, 1);
          break;
      }
    },
    save(type) {
      this.$store.dispatch('SAVE_NOTIFICATION_SETTINGS', type)
        .then(() => {
          this.$store.dispatch('GET_NOTIFICATION_SETTINGS');
          this.$toaster.success('Настройки сохранены');
        })
        .catch(() => {
          this.$toaster.error('Неизвестная ошибка');
        });
    },
    changeSenDom(index, event) {
        const sms = this.settings.sms[index];
        if (event === 'domain') {
            if (this.domains.includes(sms.domain) && this.senders.includes(sms.domain.toUpperCase())) {
                this.settings.sms[index].sender = sms.domain.toUpperCase();
            }
        }
        else {
            if (this.domains.includes(sms.sender.toLowerCase()) && this.senders.includes(sms.sender)) {
                this.settings.sms[index].domain = sms.sender.toLowerCase();
            }
        }
    },
    switchShow(notification) {
        this.$store.dispatch("UPDATE_NOTIFICATION_IS_USED", notification);
    },
  },
};
</script>

<style>
    .tabs.is-toggle li.is-active a {
        background-color: #1d8f68;
    }
    .notification-row {
        background-color: #fff;
        border: solid 1px #cecece;
        border-radius: 5px;
        padding: 10px;
    }
</style>
